import { render, staticRenderFns } from "./AutorizationList.vue?vue&type=template&id=371c53e4&"
import script from "./AutorizationList.vue?vue&type=script&lang=js&"
export * from "./AutorizationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports